import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {StatesDTO} from './states.dto';
export class StatesResponseModel extends GlobalResponseObject {
  data?: StatesDTO;
  response: StatesDTO[];
}

export class StatesStatusWiseResponseModel extends GlobalResponseObject {
  data?:StatesDTO[];
  active?:number;
  inActive?:number;
  total?:number;
}


